import React from "react";
import Image from "next/image";
import * as Icon from "@phosphor-icons/react/dist/ssr";
import { Avatar, Tag } from "antd";
import moment from "moment/moment";
import { type Blog } from "@/lib/@types/api/blog";
import { Link } from "@/navigation";
import { CalendarTwoTone } from "@ant-design/icons";

interface BlogProps {
	news: Blog.BlogListItem;
}

const BlogItemDefault: React.FC<BlogProps> = ({ news }) => {
	return (
		<>
			<Link
				href={"/blog/" + news.blog_slug}
				className="block transform cursor-pointer overflow-hidden  rounded-lg bg-white shadow-lg transition-all duration-700 hover:-translate-y-2 hover:shadow-[#a8b7d2]"
			>
				{news.blog_cover_type ? (
					<img
						alt={news.blog_title}
						className="mb-4 h-[350px] w-full object-cover"
						src={news.blog_cover_origin}
						width="600"
					/>
				) : (
					<video
						autoPlay
						muted
						loop
						playsInline
						className="mb-4 h-[350px] w-full object-cover"
						src={news.blog_cover_origin}
						width="600"
					/>
				)}

				<div className="px-4 py-6">
					<div className="flex gap-x-1 overflow-hidden ">
						{news.blog_classification_list &&
							news.blog_classification_list.map((item) => {
								return (
									<Tag color="" className=" text-xs uppercase  " key={item.cls_slug}>
										{item.cls_name}
									</Tag>
								);
							})}
					</div>
					<h3 className="my-2  line-clamp-2 h-14 !text-xl  font-bold text-black">{news.blog_title}</h3>
					<p className="my-2 line-clamp-2 text-xs font-normal text-[#677E6E] max-md:my-1 sm:text-sm ">
						{news.blog_excerpt}
					</p>
					<div className="mt-5 flex items-center justify-between gap-x-1 !text-xs text-gray-500">
						<div className="flex items-center">
							{/* <Avatar size={30} src={<img src="/image/logo.png" alt="blog avatar" />} /> */}
							{/* <span className="ml-2  text-[1rem]">{process.env.NEXT_PUBLIC_COMPANY_NAME}</span> */}
						</div>
						<div>
							<div className="text-[1rem]">
								<CalendarTwoTone /> {moment(news.blog_upload_time).format("MMM DD YYYY")}
								{/*<div className="w-[28px] h-[2px] bg-main max-lg:w-[16px] mb-2"></div>*/}
							</div>
						</div>
					</div>
					{/*<span  className="text-black text-xs hover:text-main">READ MORE</span>*/}
				</div>
			</Link>
		</>
	);
};

export default BlogItemDefault;
